import { render, staticRenderFns } from "./Lobby6.vue?vue&type=template&id=1e95d406&"
import script from "./Lobby6.vue?vue&type=script&lang=js&"
export * from "./Lobby6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports